"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRagSearchTool = void 0;
const zod_1 = require("zod");
const getRagSearchTool = (noHtml = false) => ({
    name: 'ragSearch',
    description: `Search through uploaded knowledge files and documents using RAG (Retrieval Augmented Generation). 
        Use this tool when the user asks a question and knowledge files are present.
        The tool searches through indexed files and returns relevant content chunks with similarity scores.
        
        Available knowledge files are described in the system message as tool data entries.
        Always call this tool when knowledge files are available. Search them before answering, even if the question doesn't explicitly mention them. The LLM can use the retrieved information to provide more accurate and informed answers.
        
        ${!noHtml ? `Mark paragraphs containing information from RAG sources with: <p class="from-rag"></p>` : ''}
        ${!noHtml ? `Mark your own answers with: <p class="from-ai-network"></p>` : ''}
    `,
    zodSchema: zod_1.z.object({
        query: zod_1.z.string().describe('The search query to find relevant information in the knowledge base. Use the user\'s question or a refined version of it.'),
        language: zod_1.z.string().optional().describe('The language for the search results (e.g., "en", "pl", "de"). Defaults to request language.')
    }),
    blockStream: false
});
exports.getRagSearchTool = getRagSearchTool;
